export default "__VITE_ASSET__DtcaRkQG__"